import { Route } from "react-router-dom";

import DashboardLayout from "components/layouts/DashboardLayout";

import Dashboard from "pages/webmaster";
import Notifications from "pages/shared/notifications";
import Settings from "pages/webmaster/settings";
import Tasks from "pages/webmaster/tasks";
import TaskSingle from "pages/webmaster/tasks/single";
import WebmastersDetails from "pages/webmaster/webmasters";
import Faq from "pages/shared/faq";

const webmasterRoutes = () => {
  return (
    <Route element={<DashboardLayout />}>
      <Route index element={<Dashboard />} />
      <Route path="/tasks">
        <Route index element={<Tasks />} />
        <Route path=":id" element={<TaskSingle />} />
      </Route>
      <Route path="/webmasters/:id" element={<WebmastersDetails />} />
      <Route path="/notifications" element={<Notifications />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/faq" element={<Faq />} />
    </Route>
  );
};

export default webmasterRoutes;
